import {
    GET_SEEDING_BONUS,
    FB_POST_GET_LIST_SEEDING,
    FB_POST_GET_LIST_REACTION,
    FB_POST_SAVE_PROCESS,
    POST_SEEDING_BONUS,
    FB_POST_GET_LIST_ORDER,
    FB_FAN_PAGE_SAVE_PROCESS,
    FB_GROUP_SAVE_PROCESS,
    FB_LIKE_COMMENT_SAVE_PROCESS,
    FB_FOLLOW_SAVE_PROCESS,
    FB_JOB_CALCULATE,
    UVIEW_JOB_CALCULATE,
    UVIEW_POST_GET_LIST_SEEDING,
    INSTA_LIKE_SAVE_PROCESS,
    INSTA_GET_LIST_ORDER,
    INSTA_FOLLOW_SAVE_PROCESS,
    INSTA_COMMENT_SAVE_PROCESS,
    FB_GET_POST_ID,
    FB_GET_PAGE_ID,
    SYNC_DATA_FROM_TIKTOK,
    UVIEW_SYNC_DATA,
    FB_GET_PROFILE_ID,
    VIP_LIKE_CLONE_SAVE_PROCESS,
    VIP_LIKE_MONTH_SAVE_PROCESS,
    VIP_LIKE_MONTH_INSTAGRAM_SAVE_PROCESS,
    VIP_LIKE_MOUNT_SAVE_PROCESS,
    VIP_REACTION_MONTH_SAVE_PROCESS,
    VIP_COMMENT_MONTH_SAVE_PROCESS,
    VIP_COMMENT_MONTH_INSTAGRAM_SAVE_PROCESS,
    VIP_FACE_GET_SEEDING,
    VIP_FACE_CALCULATE,
    VIP_INSTAGRAM_CALCULATE,
    VIP_REACTION_FACE_CALCULATE,
    VIP_FACE_LIST,
    FB_GET_PROFILE_ID_BUFF,
    FB_STREAM_SAVE_PROCESS,
    FB_STREAM_GET_LIST_ORDER,
    FB_JOB_CANCEL_ORDER,
    INSTA_JOB_CANCEL_ORDER,
    VIP_FACE_LOG,
    VIP_INSTAGRAM_LOG,
    VIP_CANCEL_ORDER,
    FB_REVIEW_SAVE_PROCESS,
    TIKTOK_REACTION_SAVE_PROCESS,
    TIKTOK_GET_LIST_ORDER,
    UVIEW_GET_LIST_ORDER,
    UVIEW_JOB_SUCCESS_ORDER,
    TIKTOK_COMMENT_SAVE_PROCESS,
    TIKTOK_FOLLOW_SAVE_PROCESS,
    TIKTOK_VIEW_SAVE_PROCESS,
    FACEBOOK_VIEW_SAVE_PROCESS,
    YOUTUBE_VIEW_SAVE_PROCESS,
    TIKTOK_JOB_CANCEL_ORDER,
    SYNC_DATA_FROM_FB,
    SYNC_DATA_FROM_INSTA,
    FB_JOB_SUCCESS_ORDER,
    FB_JOB_EDIT_ORDER,
    INSTA_JOB_SUCCESS_ORDER,
    INSTA_JOB_EDIT_ORDER,
    TIKTOK_JOB_SUCCESS_ORDER,
    TIKTOK_JOB_EDIT_ORDER,
    SEEDING_TYPE_MAINTAIN,
    BOT_INTERACTION_GET_USER_FORM,
    BOT_INTERACTION_SAVE_ORDER,
    BOT_INTERACTION_GET_USER_COOKIE,
    BOT_INTERACTION_GET_LIST_PROXY,
    BOT_INTERACTION_BUY_PROXY,
    BOT_INTERACTION_GET_LIST_PROXY_ORDER,
    BOT_INTERACTION_GET_LIST_BOT_ORDER,
    BOT_INTERACTION_GET_DIARY,
    BOT_INTERACTION_EXTEND_DATE,
    BOT_INTERACTION_DELETE_ORDER,
    BOT_INTERACTION_UPDATE_COOKIE,
    BOT_INTERACTION_STOP_ORDER,
    BOT_INTERACTION_START_ORDER,
    BOT_INTERACTION_EXTEND_DATE_PROXY,
    BOT_INTERACTION_GET_IMAGE_THEME,
    BOT_INTERACTION_UPDATE_ORDER,
    BOT_INTERACTION_GET_ORDER,
    BOT_INTERACTION_GET_STICKER_IMAGE,
    CUSTOMER_LEVEL_PRICE_LIST,
    CUSTOMER_LEVEL_PROFILE,
    SHARE_STREAM_GET_GROUP,
    SHARE_STREAM_GET_STREAM,
    SHARE_STREAM_GET_PRICE,
    SHARE_STREAM_SAVE_ORDER,
    TELEGRAM_HISTORY,
    TELEGRAM_SAVE_PROCESS,
    SEEDING_TYPE_MAINTAIN_BY_ID,
    POST_GROUP_GET_PRICE,
    POST_GROUP_SAVE_ORDER,
    POST_GROUP_GET_LOG,
    REPORT_PAYMENT_ERROR,
    BUFF_TAY_GET_PRICE,
    BUFF_TAY_SAVE_ORDER,
    BUFF_LIKE_YOUTUBE_SAVE_ORDER,
    BUFF_4K_VIEW_YOUTUBE_SAVE_ORDER,
    VIP_LIKE_MONTH_INSTAGRAM_UPDATE_PROCESS,
    VIP_LIKE_MONTH_INSTAGRAM_SUCCESS_ORDER,
    TIKTOK_VIP_LIKE_SAVE_ORDER,
    VIP_TIKTOK_GET_LOG,
} from "~/store/actions.type";
import {COMMON_SET_SNACK} from "~/store/mutations.type";
import ApiService from "~/common/service.api";
import {getErrorMsg} from "~/common/helper.string";

const state = {};

// getters
const getters = {};

// actions
const actions = {
    [FB_GET_POST_ID](params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("facebook-account/get-post-id", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      // commit(COMMON_SET_SNACK, {
                      //     message: resp.data.message,
                      //     type: "error"
                      // });
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [FB_GET_PAGE_ID](params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("get-page-id", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      // commit(COMMON_SET_SNACK, {
                      //     message: resp.data.message,
                      //     type: "error"
                      // });
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [FB_GET_PROFILE_ID]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("facebook-account/get-uid-by-profile", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      resolve(false);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [FB_GET_PROFILE_ID_BUFF](params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("facebook-account/get-uid-by-profile", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [FB_POST_GET_LIST_SEEDING]() {
        return new Promise((resolve) => {
            ApiService.get("facebook-jobs/list-seeding")
              .then(resp => {
                  if (resp.data.success) {
                      //localStorage.setItem(FB_POST_GET_LIST_SEEDING, JSON.stringify(resp.data.data));
                      resolve(resp.data.data);
                  } else {
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    [GET_SEEDING_BONUS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("jobs/get-bonus-data", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    [GET_SEEDING_BONUS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("jobs/get-bonus-data", params)
                .then(resp => {
                    if (resp.data.success) {
                        resolve(resp.data.data);
                    } else {
                        commit();
                        resolve(false);
                    }
                })
                .catch(() => {
                    resolve(false);
                });
        });
    },
    [FB_POST_GET_LIST_REACTION]() {
        return new Promise((resolve) => {
            ApiService.get("facebook-jobs/list-reactions")
              .then(resp => {
                  if (resp.data.success) {
                      //localStorage.setItem(FB_POST_GET_LIST_REACTION, JSON.stringify(resp.data.data));
                      resolve(resp.data.data);
                  } else {
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [FB_POST_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-jobs", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [POST_SEEDING_BONUS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("jobs/save-job-bonus", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [POST_SEEDING_BONUS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("jobs/save-job-bonus", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [FB_POST_GET_LIST_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("facebook-jobs", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [FB_JOB_CANCEL_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post(`facebook-jobs/cancel-order?id=${params}`)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    [FB_STREAM_GET_LIST_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("facebook-jobs", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [FB_FAN_PAGE_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-like-page", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    [FB_GROUP_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-group", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    [FB_LIKE_COMMENT_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-like-comment", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    [FB_JOB_CALCULATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-jobs/calculate", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [UVIEW_JOB_CALCULATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("view-caculate", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [UVIEW_POST_GET_LIST_SEEDING]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("view-type", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [FB_FOLLOW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-follow", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    // insta gram
    [INSTA_LIKE_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-jobs/reaction-post", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [INSTA_GET_LIST_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("instagram-jobs", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [INSTA_FOLLOW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-jobs/follow-profile", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [INSTA_COMMENT_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-jobs/comment-post", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [INSTA_JOB_CANCEL_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post(`instagram-jobs/cancel-order?id=${params}`)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    // Vip face
    [VIP_FACE_GET_SEEDING]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("seeding-type/get-seeding-type", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_LIKE_CLONE_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/vip-like-clone", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_LIKE_MONTH_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/vip-like-month", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_LIKE_MONTH_INSTAGRAM_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-vip/vip-like-month", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_LIKE_MONTH_INSTAGRAM_UPDATE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-vip/vip-like-month/update", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [VIP_LIKE_MONTH_INSTAGRAM_SUCCESS_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("instagram-vip/vip-like-month/success?id=" + params)
                .then(resp => {
                    if (resp.data.success) {
                        resolve(resp.data.data);
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });

        })
    },

    [VIP_LIKE_MOUNT_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/vip-like-count", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_REACTION_MONTH_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/vip-like-reaction", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    [VIP_COMMENT_MONTH_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/comment-post-month", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_COMMENT_MONTH_INSTAGRAM_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-vip/comment-post-month", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    [VIP_FACE_CALCULATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/caculate-vip", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [VIP_INSTAGRAM_CALCULATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("instagram-vip/caculate-vip", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    [VIP_REACTION_FACE_CALCULATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-vip/caculate-vip-reaction", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    [VIP_FACE_LIST]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string(params.api_route, {'search' : params.search})
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
//cancel order VIP
    [VIP_CANCEL_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post(`facebook-vip/cancel-order?id=${params}`)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    [FB_STREAM_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-stream", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },
    [FB_REVIEW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-review", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },


    [SYNC_DATA_FROM_FB]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("facebook-jobs/sync-job?id=" + params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },
    [SYNC_DATA_FROM_INSTA]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("instagram-jobs/sync-job?id=" + params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [SYNC_DATA_FROM_TIKTOK]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("tiktok-jobs/sync-job?id=" + params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [VIP_FACE_LOG]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("facebook-vip/log/vip-seeding", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [VIP_INSTAGRAM_LOG]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("instagram-vip/log/vip-seeding", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    // //TIKTOK
    // [TIKTOK_REACTION_SAVE_PROCESS]({commit}, params) {
    //     return new Promise((resolve) => {
    //         ApiService.post("tiktok-reaction-post", params)
    //             .then(resp => {
    //                 if (resp.data.success) {
    //                     commit(COMMON_SET_SNACK, {
    //                         message: resp.data.message,
    //                         type: "success"
    //                     });
    //                     resolve(true);
    //                 } else {
    //                     commit(COMMON_SET_SNACK, {
    //                         message: resp.data.message,
    //                         type: "error"
    //                     });
    //                     resolve(false);
    //                 }
    //             })
    //             .catch((err) => {
    //                 commit(COMMON_SET_SNACK, {
    //                     message: getErrorMsg(err),
    //                     type: "error"
    //                 });
    //                 resolve(false);
    //             });
    //
    //     })
    // },

    // Tiktok reaction save
    [TIKTOK_REACTION_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("tiktok-jobs/reaction-post", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    // Tiktok reaction save
    [TIKTOK_VIEW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("tiktok-view", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    // facebook reaction save
    [FACEBOOK_VIEW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("facebook-view", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    // youtube reaction save
    [YOUTUBE_VIEW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("youtube-view", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

// Tiktok follow save
    [TIKTOK_FOLLOW_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("tiktok-jobs/follow-profile", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

//Tiktok comment save
    [TIKTOK_COMMENT_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("tiktok-jobs/comment-post", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

// Lay danh sach job tiktok
    [TIKTOK_GET_LIST_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("tiktok-jobs", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [UVIEW_GET_LIST_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("view-list", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch(err => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
    [UVIEW_JOB_SUCCESS_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("view-cancel", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [UVIEW_SYNC_DATA]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("view-sync", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },
//cancel job tiktok
    [TIKTOK_JOB_CANCEL_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post(`tiktok-jobs/cancel-order?id=${params}`)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data);
                  } else {
                      commit();
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },
    //fb success job
    [FB_JOB_SUCCESS_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("facebook-jobs/success-job?id=" + params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    //inss success job
    [INSTA_JOB_SUCCESS_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("instagram-jobs/success-job?id=" + params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    //tiktok success job
    [TIKTOK_JOB_SUCCESS_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.get("tiktok-jobs/success-job?id=" + params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    //fb edit job
    [FB_JOB_EDIT_ORDER]({commit}, id, seed_plus) {
        return new Promise((resolve) => {
            ApiService.get("facebook-jobs/success-job?id=" + id +'&seed_plus=' + seed_plus)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    //ins success job
    [INSTA_JOB_EDIT_ORDER]({commit}, id, seed_plus) {
        return new Promise((resolve) => {
            ApiService.get("instagram-jobs/success-job?id=" + id +'&seed_plus=' + seed_plus)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    //tiktok success job
    [TIKTOK_JOB_EDIT_ORDER]({commit}, id, seed_plus) {
        return new Promise((resolve) => {
            ApiService.get("tiktok-jobs/success-job?id=" + id +'&seed_plus=' + seed_plus)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    // seeding_type maintain
    [SEEDING_TYPE_MAINTAIN]() {
        return new Promise((resolve) => {
            ApiService.get("get-seeding-type-maintain")
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                  } else {
                      resolve(false);
                  }
              })
              .catch(() => {
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_GET_IMAGE_THEME]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/get-image-theme", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [BOT_INTERACTION_BUY_PROXY]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/buy-proxy", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_GET_LIST_PROXY_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/list-proxy-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },


    // bot interaction
    [BOT_INTERACTION_GET_USER_FORM]({commit}) {
        return new Promise((resolve) => {
            ApiService.get("interaction-bot/form-order")
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [BOT_INTERACTION_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/create-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_GET_USER_COOKIE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/user-info-cookie", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [BOT_INTERACTION_GET_LIST_BOT_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/list-bot-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [BOT_INTERACTION_GET_DIARY]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/diary-today", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [BOT_INTERACTION_EXTEND_DATE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/extend-date", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_DELETE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/delete-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_UPDATE_COOKIE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/update-cookie", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_STOP_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/stop-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_START_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/start-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_GET_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/get-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        })
    },

    [BOT_INTERACTION_EXTEND_DATE_PROXY]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/extend-proxy", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_UPDATE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("interaction-bot/update-order", params)
              .then(resp => {
                  if (resp.data.success) {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "success"
                      });
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        });
    },

    [BOT_INTERACTION_GET_LIST_PROXY]({commit}) {
        return new Promise((resolve) => {
            ApiService.get("interaction-bot/get-list-proxy")
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });

        })
    },

    [BOT_INTERACTION_GET_STICKER_IMAGE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("interaction-bot/get-sticker-image", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        })
    },

    // customer level
    [CUSTOMER_LEVEL_PRICE_LIST]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("customer-level/price-list", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        })
    },

    [CUSTOMER_LEVEL_PROFILE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("customer-level/profile", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        })
    },

    // customer level
    [CUSTOMER_LEVEL_PRICE_LIST]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("customer-level/price-list", params)
              .then(resp => {
                  if (resp.data.success) {
                      resolve(resp.data.data);
                      resolve(true);
                  } else {
                      commit(COMMON_SET_SNACK, {
                          message: resp.data.message,
                          type: "error"
                      });
                      resolve(false);
                  }
              })
              .catch((err) => {
                  commit(COMMON_SET_SNACK, {
                      message: getErrorMsg(err),
                      type: "error"
                  });
                  resolve(false);
              });
        })
    },

    [SHARE_STREAM_GET_GROUP]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("share-stream/get-group", params)
                .then(resp => {
                    if (resp.data.data.status) {
                        resolve(resp.data.data.entry);
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    [SHARE_STREAM_GET_STREAM]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("share-stream/get-stream", params)
                .then(resp => {
                    if (resp.data.data.status) {
                        resolve(resp.data.data.entry);
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    [SHARE_STREAM_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("share-stream/store-order", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [SHARE_STREAM_GET_PRICE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("share-stream/create", params)
                .then(resp => {
                    if (resp.data.data.status) {
                        resolve(resp.data.data);
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    // telegram
    [TELEGRAM_HISTORY]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("telegram", params)
                .then(resp => {
                    if (resp.data.success) {
                        resolve(resp.data.data);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch(err => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },
    [TELEGRAM_SAVE_PROCESS]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("telegram", params)
            .then(resp => {
                if (resp.data.success) {
                    commit(COMMON_SET_SNACK, {
                        message: resp.data.message,
                        type: "success"
                    });
                    resolve(true);
                } else {
                    commit(COMMON_SET_SNACK, {
                        message: resp.data.message,
                        type: "error"
                    });
                    resolve(false);
                }
            })
            .catch((err) => {
                commit(COMMON_SET_SNACK, {
                    message: getErrorMsg(err),
                    type: "error"
                });
                resolve(false);
            });
        });
    },

    [SEEDING_TYPE_MAINTAIN_BY_ID]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("get-maintain-by-id", params)
                .then(resp => {
                    resolve(resp.data.data);
                    resolve(true);
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    //post group
    [POST_GROUP_GET_PRICE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("post-group/create", params)
                .then(resp => {
                    if (resp.data.data.status) {
                        resolve(resp.data.data);
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    [POST_GROUP_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("post-group/store-order", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },
    [POST_GROUP_GET_LOG]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("post-group/get-log", params)
                .then(resp => {
                    if (resp.data.data.status) {
                        resolve(resp.data.data);
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    // report
  [REPORT_PAYMENT_ERROR]({commit}, params) {
    return new Promise((resolve) => {
      ApiService.post("report/payment-error", params)
        .then(resp => {
          if (resp.data.success) {
            commit(COMMON_SET_SNACK, {
              message: resp.data.message,
              type: "success"
            });
            resolve(true);
          } else {
            commit(COMMON_SET_SNACK, {
              message: resp.data.message,
              type: "error"
            });
            resolve(false);
          }
        })
        .catch((err) => {
          commit(COMMON_SET_SNACK, {
            message: getErrorMsg(err),
            type: "error"
          });
          resolve(false);
        });
    });
  },

    //buff tây
    [BUFF_TAY_GET_PRICE]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("buff-tay/create", params)
                .then(resp => {
                    if (resp.data.data.status) {
                        resolve(resp.data.data);
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        })
    },

    [BUFF_TAY_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("buff-tay/store-order", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [BUFF_LIKE_YOUTUBE_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("youtube-like", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [BUFF_4K_VIEW_YOUTUBE_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("youtube-4k-view", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [TIKTOK_VIP_LIKE_SAVE_ORDER]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.post("tiktok-vip-like/store-order", params)
                .then(resp => {
                    if (resp.data.success) {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "success"
                        });
                        resolve(true);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch((err) => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },

    [VIP_TIKTOK_GET_LOG]({commit}, params) {
        return new Promise((resolve) => {
            ApiService.query_params_string("tiktok-vip-like/get-log", params)
                .then(resp => {
                    if (resp.data.success) {
                        resolve(resp.data.data);
                    } else {
                        commit(COMMON_SET_SNACK, {
                            message: resp.data.message,
                            type: "error"
                        });
                        resolve(false);
                    }
                })
                .catch(err => {
                    commit(COMMON_SET_SNACK, {
                        message: getErrorMsg(err),
                        type: "error"
                    });
                    resolve(false);
                });
        });
    },
};


// mutations
const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
};
